import { HttpHeaders } from '@angular/common/http';

export interface PaginationMeta {
  firstPage?: number;
  previousPage?: number;
  currentPage?: number;
  nextPage?: number;
  lastPage?: number;
  totalItemCount?: number;
}

export function parsePaginationHeaders(headers: HttpHeaders, fallbackPage: number): PaginationMeta {
  const num = (key: string): number | undefined => {
    const val = headers.get(key);
    return val ? +val : undefined;
  };
  return {
    firstPage: num('First-Page'),
    previousPage: num('Previous-Page'),
    currentPage: +(headers.get('Current-Page') ?? '') || fallbackPage,
    nextPage: num('Next-Page'),
    lastPage: num('Last-Page'),
    totalItemCount: num('Total-Item-Count'),
  };
}
